import MUIDataTable from 'mui-datatables';
import { UPTableProps } from './types';

const UPTable = (props: UPTableProps): JSX.Element => {
  const { data, columns, options } = props;
  return <MUIDataTable data={data} columns={columns} options={options} />;
};

export default UPTable;
